import api from '../../api';

const namespaced = true;

const state = {
  applications: {},
  currentCategory: -1,
  currentType: 0,
};

const getters = {
  getApplications: (state) => {
    return state.applications;
  },
  getCurrentCategory: (state) => {
    return state.currentCategory;
  },
  getCurrentType: (state) => {
    return state.currentType;
  },
  getApplicationSelection: (state) => {
    if (state.currentCategory > 0) {
      const categoryArray = state.applications;
      let selected = 0;
      for (const key in categoryArray[state.currentCategory].apps) {
        selected += categoryArray[state.currentCategory].apps[key].selected;
      }
      return selected;
    }
    return 0;
  },
  getCategorySelection: (state) => {
    const categoryArray = state.applications;
    let selected = 0;
    for (const key in categoryArray) {
      selected += categoryArray[key].selected;
    }
    return selected;
  },
  getFirstCategory: (state) => {
    const categoryArray = state.applications;
    for (const ackey in categoryArray) {
      if (categoryArray[ackey].selected) {
        return ackey;
      }
    }
    return 0;
  },
  getNextCategory: (state) => {
    const categoryArray = state.applications;
    const currentCategory = state.currentCategory;
    let selectedCategory = 0;
    for (const ackey in categoryArray) {
      if (selectedCategory !== 0 && categoryArray[ackey].selected) {
        return ackey;
      }
      if (currentCategory === ackey) {
        // this will tell me in the next loop
        // that that iteration is the one after the currently selected category
        selectedCategory = ackey;
      }
    }
    return 0;
  },
  getNextEmptyCategory: (state) => {
    const categoryArray = state.applications;
    for (const ackey in categoryArray) {
      if (categoryArray[ackey].selected) {
        let selected = 0;
        for (const apkey in categoryArray[ackey].apps) {
          selected += categoryArray[ackey].apps[apkey].selected;
        }
        if (selected === 0) {
          return ackey;
        }
      }
    }
    return 0;
  },
};

const mutations = {
  setApplications: (state, payload) => {
    state.applications = payload;
  },
  toggleApplicationSelection: (state, payload) => {
    state.applications[state.currentCategory].apps[payload].selected
      = !state.applications[state.currentCategory].apps[payload].selected;
  },
  toggleCategorySelection: (state, payload) => {
    state.applications[payload].selected
      = !state.applications[payload].selected;
  },
  setCurrentCategory: (state, payload) => {
    state.currentCategory = payload;
  },
  setCurrentType: (state, payload) => {
    state.currentType = payload;
  },
};

const actions = {
  fetchApplications: ({ commit }, payload) => {
    api.getApplications({ lang: payload.lang, type: payload.type })
      .then(response => response.json())
      .then((data) => {
        commit('setApplications', data);
        commit('setCurrentType', payload.type);
      });
  },
  toggleApplicationSelection: ({ commit, rootState }, payload) => {
    commit('toggleApplicationSelection', payload);
    commit('removeError', rootState.text['0016'], { root: true });
  },
  toggleCategorySelection: ({ commit, rootState }, payload) => {
    commit('toggleCategorySelection', payload);
    commit('removeError', rootState.text['0014'], { root: true });
  },
  resetApplications: ({ commit }) => {
    commit('setApplications', {});
    commit('setCurrentType', 0);
  },
  setCurrentCategory: ({ commit }, payload) => {
    commit('setCurrentCategory', payload);
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/application.js